/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiIconTip } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { ReactNode } from 'react'

const InternalField = ({ children }: { children: ReactNode }) => (
  <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
    <EuiFlexItem grow={false}>{children}</EuiFlexItem>
    <EuiFlexItem grow={false}>
      <EuiIconTip
        type='eyeClosed'
        color='primary'
        content={
          <FormattedMessage
            id='admin-only-panel.message'
            defaultMessage='Only visible to Elastic'
          />
        }
      />
    </EuiFlexItem>
  </EuiFlexGroup>
)

export default InternalField
